var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 58,
    viewBox: "0 0 90 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.1422 0.666016H2.72035L1.41705 1.08308L2.40758 2.85559L1.57345 5.46223L3.34596 7.86033L1 15.0025L3.60664 19.2253L4.0237 23.2916L7.51659 29.1826L7.88152 33.8224L10.2796 38.358L11.0616 44.0404L10.8531 51.4954L13.0948 53.9978L67.1564 53.3722L70.3886 57.3343H72.1611L72.0569 53.8935L75.9147 51.8603V49.3058L78.0521 47.2205L77.8957 44.9788L75.654 42.3722L76.5924 38.8793L81.7536 37.8366L86.6019 35.5949L86.5498 33.1447L88.1659 31.5807L89 26.3153L85.1943 24.23L84.9336 21.9883L81.91 19.0167L81.545 16.9314L76.2275 14.4812L74.8199 8.06886L76.5924 4.99303L74.455 3.68971L74.1422 0.666016Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapImage);
export default __webpack_public_path__ + "static/media/mapImage.ffc18cfcf9adfc43612fa0303a1dfe45.svg";
export { ForwardRef as ReactComponent };